import { Link } from 'react-router-dom';
import { QuizEngine } from '../components/QuizEngine';

const questions = [
  {
    question: 'Was ist dir beim Wohnen am wichtigsten?',
    options: [
      'Natur und Ruhe – Berge, Wälder, frische Luft',
      'Kultur und Kulinarik – Restaurants, Events, Geschichte',
      'Urbanes Flair – Einkaufen, Ausgehen, Infrastruktur',
      'Familienfreundlichkeit – Schulen, Spielplätze, Gemeinschaft'
    ],
    correctAnswer: 0,
    explanation: 'Deine Prioritäten bestimmen, welche Region am besten passt. Das Pustertal bietet Natur, Meran Kulinarik, Bozen urbanes Flair.'
  },
  {
    question: 'Wie wichtig sind dir kurze Wege zur Arbeit?',
    options: [
      'Sehr wichtig – ich möchte zu Fuß oder mit dem Rad fahren können',
      'Wichtig – 30 Minuten mit dem Auto wären okay',
      'Weniger wichtig – für die richtige Wohnqualität fahre ich auch weiter',
      'Egal – ich arbeite remote oder bin selbstständig'
    ],
    correctAnswer: 1,
    explanation: 'Pendeln in Südtirol kann aufgrund der Topografie und des Verkehrs zur Herausforderung werden. Plane realistisch!'
  },
  {
    question: 'Welche Jahreszeit genießt du am meisten?',
    options: [
      'Winter – Skifahren, Schneeschuhwandern, gemütliche Abende',
      'Sommer – Wandern, Schwimmen, draußen sein',
      'Frühling/Herbst – Weinlese, milde Temperaturen, Farben',
      'Alle gleich – ich mag Abwechslung'
    ],
    correctAnswer: 3,
    explanation: 'Das Klima variiert stark: Das Etschtal ist mediterran, die höheren Lagen alpin. Überlege, wo du dich wohler fühlst.'
  },
  {
    question: 'Wie stehst du zum Thema Sprache?',
    options: [
      'Ich spreche fließend Deutsch und möchte in einer deutschsprachigen Umgebung leben',
      'Ich bin zweisprachig oder offen für beide Sprachen',
      'Italienisch ist mir vertrauter',
      'Sprache ist zweitrangig – ich bin anpassungsfähig'
    ],
    correctAnswer: 1,
    explanation: 'Die Sprachverteilung variiert regional. Im Unterland ist mehr Italienisch präsent, im Pustertal fast nur Deutsch.'
  },
  {
    question: 'Wie hoch ist dein Budget für Wohnen?',
    options: [
      'Eher begrenzt – ich suche günstigere Lagen',
      'Mittel – ich bin flexibel, aber preisbewusst',
      'Gehobenes Budget – Lage und Qualität sind wichtiger als der Preis',
      'Sehr hoch – ich suche etwas Besonderes'
    ],
    correctAnswer: 1,
    explanation: 'Die Preise variieren stark: Bozen und Meran sind am teuersten, ländlichere Regionen deutlich günstiger.'
  }
];

const resultMessages = {
  excellent: 'Du hast klare Vorstellungen vom Wohnen in Südtirol! Das hilft bei der Suche.',
  good: 'Du weißt, was du willst – jetzt geht es darum, die passende Region zu finden.',
  average: 'Vielfältige Interessen machen die Wahl nicht leichter, aber Südtirol hat für jeden etwas.',
  needsWork: 'Am besten besuchst du verschiedene Regionen, um ein Gefühl für die Unterschiede zu bekommen.'
};

const relatedLinks = [
  { path: '/ratgeber/hausbau-in-suedtirol', label: 'Hausbau in Südtirol' },
  { path: '/immobilien/wohnung-kaufen-oder-mieten', label: 'Kaufen oder Mieten?' },
  { path: '/tippspiele/was-kostet-dieses-haus', label: 'Was kostet dieses Haus?' }
];

export default function WohnenInSuedtirol() {
  return (
    <div className="section-spacing" data-testid="wohnen-suedtirol-page">
      <div className="container-wide">
        {/* Breadcrumb */}
        <nav className="text-sm text-[#64748B] mb-8" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-[#0284C7]">Start</Link>
          <span className="mx-2">/</span>
          <Link to="/suedtirol" className="hover:text-[#0284C7]">Südtirol</Link>
          <span className="mx-2">/</span>
          <span className="text-[#0F172A]">Wohnen in Südtirol</span>
        </nav>

        <QuizEngine
          title="Wohnen in Südtirol – was passt zu dir?"
          introText="Südtirol ist vielfältig: von urban bis alpin, von weinbepflanzt bis hochalpin. Finde heraus, welche Region zu deinem Lebensstil passt."
          questions={questions}
          resultMessages={resultMessages}
          relatedLinks={relatedLinks}
        />

        {/* SEO Content */}
        <div className="mt-16 advisor-content">
          <h2>Die Regionen Südtirols im Überblick</h2>
          <p>
            Südtirol bietet auf kleinem Raum eine enorme Vielfalt. Von der 
            Landeshauptstadt Bozen über das mondäne Meran bis zu den 
            naturnahen Tälern – jede Region hat ihren eigenen Charakter.
          </p>
          
          <h3>Bozen und Umgebung</h3>
          <p>
            Die Landeshauptstadt bietet urbanes Flair, gute Infrastruktur und 
            kurze Wege. Ideal für alle, die Stadtnähe schätzen, aber schnell 
            in der Natur sein wollen. Preislich am oberen Ende.
          </p>

          <h3>Meran und das Burggrafenamt</h3>
          <p>
            Mediterranes Klima, Palmen und Berge – Meran ist bekannt für sein 
            mildes Klima und seine Lebensqualität. Beliebt bei Zugezogenen, 
            aber auch entsprechend teuer.
          </p>

          <h3>Das Pustertal</h3>
          <p>
            Naturliebhaber und Familien schätzen das Pustertal für seine 
            Ruhe und die Nähe zu den Dolomiten. Die Preise sind moderater, 
            die Wege in die Städte aber länger.
          </p>

          <h3>Das Unterland</h3>
          <p>
            Weinbauregion mit italienischem Einschlag. Günstiger als Bozen 
            und Meran, aber gute Anbindung. Ideal für Weinliebhaber und 
            alle, die es etwas ruhiger mögen.
          </p>

          <p>
            Du suchst eine Unterkunft zum Kennenlernen der Region? Ein Aufenthalt 
            in{' '}
            <a href="https://kohlbrenner.com" target="_blank" rel="noopener noreferrer">
              einer traditionellen Südtiroler Unterkunft
            </a>{' '}
            gibt dir die Möglichkeit, das Leben vor Ort zu erleben, bevor du 
            eine dauerhafte Entscheidung triffst.
          </p>

          <div className="cta-box">
            <div className="cta-box-title">Du hast dich entschieden?</div>
            <p className="cta-box-text">
              Dann ist der nächste Schritt die Immobiliensuche. Unser Quiz 
              hilft dir, die richtige Entscheidung zwischen Kaufen und Mieten 
              zu treffen.
            </p>
            <Link to="/immobilien/wohnung-kaufen-oder-mieten" className="text-[#0284C7] font-medium hover:underline">
              Zum Quiz: Kaufen oder Mieten? →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
